import { action } from 'satcheljs';

const RESET_APPLICATION_SETTING_OVERRIDES_ACTION = 'resetApplicationSettingOverrides';

const resetApplicationSettingOverridesAction = action(RESET_APPLICATION_SETTING_OVERRIDES_ACTION);

export default resetApplicationSettingOverridesAction;
